import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Nav } from './Nav';

/**
 * App shell — top bar + role-aware sidebar + main content outlet.
 * Mirrors the Reports kit's AppShell structure (Header + Nav + <Outlet/>),
 * trimmed to what the Shipping module needs (no slicers rail, freshness banner,
 * watermark, or command palette — those are analytics-portal concerns).
 */
export function AppShell() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#fff' }}>
      <Header />
      <div style={{ display: 'flex', flex: '1 1 auto', minHeight: 0 }}>
        <Nav />
        <main
          id="main-content"
          tabIndex={-1}
          style={{ flex: '1 1 auto', minWidth: 0, overflowX: 'auto', padding: '20px 24px' }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
